import httpcommon from "../helper/httpcommon";

const removeEmptyParams = (params) => {
  return Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== "" && value !== null && value !== undefined
    )
  );
};

// Counsellor endpoints
export const fetchCounsellors = ({
  page = 1,
  pageSize = 8,
  search = "",
  city = "",
  counsellorType = "",
}) => {
  return httpcommon.get("counsellors/", {
    params: removeEmptyParams({
      page,
      page_size: pageSize,
      search,
      city,
      counsellor_type: counsellorType,
    }),
  });
};

export const fetchCounsellor = (counsellorId) => {
  return httpcommon.get(`counsellors/${counsellorId}/`);
};

export const fetchCounsellorAvailability = ({
  counsellorId,
  startDate,
  days = 7,
  timezone = "Asia/Kolkata",
}) => {
  return httpcommon.get(`counsellors/${counsellorId}/availability/`, {
    params: removeEmptyParams({
      start_date: startDate,
      days,
      timezone,
    }),
  });
};

// Create a Razorpay order + a pending appointment hold. The slot is only booked
// once the payment is verified (see verifyCounsellingPayment / webhook).
export const createCounsellingOrder = ({
  counsellorId,
  startAt,
  timezone = "Asia/Kolkata",
  studentUserId,
}) => {
  return httpcommon.post(`counsellors/${counsellorId}/appointments/`, {
    start_at: startAt,
    timezone,
    ...removeEmptyParams({ student_user_id: studentUserId }),
  });
};

// Verify the Razorpay Checkout response on the backend and confirm the booking.
export const verifyCounsellingPayment = ({
  appointmentId,
  razorpayOrderId,
  razorpayPaymentId,
  razorpaySignature,
  studentUserId,
}) => {
  return httpcommon.post(
    `counsellors/appointments/${appointmentId}/verify-payment/`,
    {
      razorpay_order_id: razorpayOrderId,
      razorpay_payment_id: razorpayPaymentId,
      razorpay_signature: razorpaySignature,
      ...removeEmptyParams({ student_user_id: studentUserId }),
    }
  );
};

// Release an unpaid hold when the user dismisses the Checkout modal.
export const cancelCounsellingPayment = ({ appointmentId, studentUserId }) => {
  return httpcommon.post(
    `counsellors/appointments/${appointmentId}/payment-cancel/`,
    removeEmptyParams({ student_user_id: studentUserId })
  );
};

export const fetchCounsellorAppointments = (studentUserId) => {
  return httpcommon.get("counsellors/appointments/", {
    params: removeEmptyParams({ student_user_id: studentUserId }),
  });
};

export const cancelCounsellorAppointment = (appointmentId, studentUserId) => {
  return httpcommon.post(
    `counsellors/appointments/${appointmentId}/cancel/`,
    removeEmptyParams({ student_user_id: studentUserId }),
  );
};

// Skill Providers endpoints
export const fetchSkillProviders = ({
  page = 1,
  pageSize = 8,
  search = "",
  skill = "",
  city = "",
}) => {
  return httpcommon.get("skill-providers/", {
    params: removeEmptyParams({
      page,
      page_size: pageSize,
      search,
      skill,
      city,
    }),
  });
};

export const fetchSkillProvider = (skillProviderId) => {
  return httpcommon.get(`skill-providers/${skillProviderId}/`);
};

export const fetchSkillProviderAvailability = ({
  skillProviderId,
  startDate,
  days = 7,
  timezone = "Asia/Kolkata",
}) => {
  return httpcommon.get(`skill-providers/${skillProviderId}/availability/`, {
    params: removeEmptyParams({
      start_date: startDate,
      days,
      timezone,
    }),
  });
};

export const bookSkillProviderAppointment = ({
  skillProviderId,
  startAt,
  timezone = "Asia/Kolkata",
  studentUserId,
}) => {
  return httpcommon.post(`skill-providers/${skillProviderId}/appointments/`, {
    start_at: startAt,
    timezone,
    ...removeEmptyParams({ student_user_id: studentUserId }),
  });
};

export const fetchSkillProviderAppointments = (studentUserId) => {
  return httpcommon.get("skill-providers/appointments/", {
    params: removeEmptyParams({ student_user_id: studentUserId }),
  });
};

export const cancelSkillProviderAppointment = (appointmentId, studentUserId) => {
  return httpcommon.post(
    `skill-providers/appointments/${appointmentId}/cancel/`,
    removeEmptyParams({ student_user_id: studentUserId }),
  );
};

// Parent-child link endpoints
export const fetchParentStudentLinks = () => {
  return httpcommon.get("school/parent-links/");
};

export const sendParentStudentLinkRequest = ({
  targetEmail,
  relationship,
  requesterRole,
}) => {
  return httpcommon.post("school/parent-links/request/", {
    target_email: targetEmail,
    relationship,
    requester_role: requesterRole,
  });
};

export const approveParentStudentLink = (linkId) => {
  return httpcommon.post(`school/parent-links/${linkId}/approve/`);
};

export const rejectParentStudentLink = (linkId) => {
  return httpcommon.post(`school/parent-links/${linkId}/reject/`);
};

export const fetchParentFeedbackStatus = (studentUserId) => {
  return httpcommon.get("school/parent-feedback/status/", {
    params: removeEmptyParams({
      student_user_id: studentUserId,
    }),
  });
};

export const fetchParentFeedbackHistory = (studentUserId) => {
  return httpcommon.get("school/parent-feedback/history/", {
    params: removeEmptyParams({
      student_user_id: studentUserId,
    }),
  });
};

export const requestParentFeedbackForAssessment = (studentUserId) => {
  return httpcommon.post("school/parent-feedback/request/", removeEmptyParams({
    student_user_id: studentUserId,
  }));
};

export const submitParentFeedbackForStudent = ({
  studentUserId,
  responses,
}) => {
  return httpcommon.post("school/parent-feedback/submit/", {
    student_user_id: studentUserId,
    responses,
  });
};

// Subscription plans (public pricing, managed from the admin dashboard)
export const fetchSubscriptionPlans = () => {
  return httpcommon.get("subscription-plans/");
};
